module.exports = __webpack_public_path__ + "img/product2.2ed55185.png";